import React from 'react';

const OnlineStatus = ({ isOnline, lastSeen, showText = false, textColor = 'text-gray-500', textSize = 'text-xs' }) => {
  const formatLastSeen = (lastSeenTimestamp) => {
    if (!lastSeenTimestamp) return 'Offline';
    
    const lastSeenDate = new Date(lastSeenTimestamp);
    if (isNaN(lastSeenDate.getTime())) return 'Offline';
    
    const now = new Date();
    const diffMs = now - lastSeenDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays}d ago`;
    
    return lastSeenDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Asia/Kolkata' });
  };

  return (
    <div className="flex items-center gap-1.5">
      {/* Online dot */}
      <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-500' : 'bg-gray-400'}`} />
      
      {/* Last seen text */}
      {showText && (
        <span className={`${textSize} ${textColor}`}>
          {isOnline ? 'Online' : formatLastSeen(lastSeen)}
        </span>
      )}
    </div>
  );
};

export default OnlineStatus;
